var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
var ValueChipTexfield = function (_a) {
    var _b, _c, _d, _e, _f;
    var suggestions = _a.valueSuggestions, _g = _a.displayMax, displayMax = _g === void 0 ? 4 : _g, _h = _a.error, error = _h === void 0 ? false : _h, label = _a.label, helperText = _a.helperText, _j = _a.values, values = _j === void 0 ? [] : _j, _k = _a.disableDefaultValuesDelete, disableDefaultValuesDelete = _k === void 0 ? false : _k, separateTopLabel = _a.separateTopLabel, onChange = _a.onChange, validateInput = _a.validateInput, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var _l = __read(useState([]), 2), valueSuggestions = _l[0], setValuesuggestions = _l[1];
    var _m = __read(useState(''), 2), currentValue = _m[0], setcurrentValue = _m[1];
    var _o = __read(useState(false), 2), isInvalidvalue = _o[0], setIsInvalidvalue = _o[1];
    var _p = __read(useState(true), 2), isBlured = _p[0], setIsBlured = _p[1];
    var inputRef = useRef(null);
    var textFieldRef = useRef(null);
    useEffect(function () {
        document.addEventListener('click', clickOutside, true);
        return function () {
            document.removeEventListener('click', clickOutside);
        };
    }, []);
    useEffect(function () {
        setValuesuggestions(suggestions !== null && suggestions !== void 0 ? suggestions : []);
        setcurrentValue('');
    }, [suggestions]);
    var clickOutside = function (ev) {
        var _a, _b;
        if (!((_a = textFieldRef.current) === null || _a === void 0 ? void 0 : _a.contains(ev.target))) {
            setIsBlured(true);
        }
        else {
            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    var handlevalueChange = function (event) {
        setcurrentValue(event.target.value);
        if (event.target.value === '') {
            setIsInvalidvalue(false);
        }
    };
    var handleKeyDown = function (event) {
        if (event.key === 'Tab' || event.key === 'Enter' || event.key === ',') {
            event.preventDefault();
            validateAndAdd();
        }
    };
    var validateAndAdd = function () {
        var _a;
        var trimmedValue = currentValue.trim();
        if (trimmedValue !== '') {
            if ((_a = validateInput === null || validateInput === void 0 ? void 0 : validateInput(trimmedValue)) !== null && _a !== void 0 ? _a : true) {
                onChange === null || onChange === void 0 ? void 0 : onChange(Array.from(new Set(__spreadArray(__spreadArray([], __read(values), false), [trimmedValue], false))));
                setcurrentValue('');
                setIsInvalidvalue(false);
            }
            else {
                setIsInvalidvalue(true);
            }
        }
    };
    var addSuggestion = function (valueToAdd) {
        var _a;
        var trimmedValue = valueToAdd.trim();
        if (trimmedValue !== '') {
            if ((_a = validateInput === null || validateInput === void 0 ? void 0 : validateInput(trimmedValue)) !== null && _a !== void 0 ? _a : true) {
                onChange === null || onChange === void 0 ? void 0 : onChange(Array.from(new Set(__spreadArray(__spreadArray([], __read(values), false), [trimmedValue], false))));
                setValuesuggestions(valueSuggestions.filter(function (value) { return value !== valueToAdd; }));
            }
        }
    };
    var handleDelete = function (valueToDelete) {
        var _a;
        if ((suggestions !== null && suggestions !== void 0 ? suggestions : []).includes(valueToDelete)) {
            setValuesuggestions(__spreadArray(__spreadArray([], __read(valueSuggestions), false), [valueToDelete], false));
        }
        onChange === null || onChange === void 0 ? void 0 : onChange((_a = (values !== null && values !== void 0 ? values : [])) === null || _a === void 0 ? void 0 : _a.filter(function (value) { return value !== valueToDelete; }));
    };
    var renderValues = function (values) {
        var _a, _b, _c;
        if (showChips)
            return React.createElement("p", null, (_a = values === null || values === void 0 ? void 0 : values.join) === null || _a === void 0 ? void 0 : _a.call(values, ', '));
        return (_c = (_b = (values !== null && values !== void 0 ? values : [])) === null || _b === void 0 ? void 0 : _b.map) === null || _c === void 0 ? void 0 : _c.call(_b, function (value, index) { return (React.createElement(React.Fragment, null,
            React.createElement(Chip, { key: index, label: value, onDelete: disableDefaultValuesDelete && (values !== null && values !== void 0 ? values : []).includes(value)
                    ? undefined
                    : function () {
                        var _a;
                        handleDelete(value);
                        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }, onClick: function (event) {
                    event.stopPropagation();
                }, style: { marginRight: '5px', marginTop: '3px', marginBottom: '3px' } }))); });
    };
    var showChips = isBlured && displayMax;
    return (React.createElement("div", { className: "lfc-value-chip-container lfc-flex lfc-flex-col" },
        separateTopLabel,
        React.createElement(TextField, { onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, ref: textFieldRef, inputRef: inputRef, label: label, value: currentValue, onChange: handlevalueChange, onKeyDown: handleKeyDown, error: error || isInvalidvalue, helperText: helperText !== null && helperText !== void 0 ? helperText : ((error || isInvalidvalue) && 'Invalid value'), onBlur: onBlur, InputProps: {
                onFocus: function (event) {
                    setIsBlured(false);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
                },
                sx: __assign({ display: 'flex', input: { width: isBlured && ((_b = (values !== null && values !== void 0 ? values : [])) === null || _b === void 0 ? void 0 : _b.length) > 0 ? 0 : undefined } }, (!showChips && { flexWrap: 'wrap' })),
                startAdornment: (React.createElement(React.Fragment, null,
                    renderValues(showChips ? (_d = (_c = (values !== null && values !== void 0 ? values : [])) === null || _c === void 0 ? void 0 : _c.slice) === null || _d === void 0 ? void 0 : _d.call(_c, 0, displayMax) : values !== null && values !== void 0 ? values : []),
                    showChips && ((_e = (values !== null && values !== void 0 ? values : [])) === null || _e === void 0 ? void 0 : _e.length) > displayMax && (React.createElement(Chip, { label: "".concat(((_f = (values !== null && values !== void 0 ? values : [])) === null || _f === void 0 ? void 0 : _f.length) - displayMax, " more"), className: "lfc-rounded-md lfc-min-h-fit" }))))
            } }),
        React.createElement("div", { className: "lfc-flex lfc-flex-wrap" }, (valueSuggestions !== null && valueSuggestions !== void 0 ? valueSuggestions : []).map(function (value, index) { return (React.createElement(Chip, { onClick: function () {
                addSuggestion(value);
            }, onDelete: function () {
                addSuggestion(value);
            }, key: "".concat(value, "-").concat(index), label: value, sx: { border: '1px solid' }, className: "lfc-mr-2 lfc-mt-2  lfc-border-primary-600 lfc-border lfc-bg-white hover:lfc-bg-primary-100 lfc-transition-colors ", deleteIcon: React.createElement(AddIcon, { fontSize: "small", className: "lfc-text-primary-600" }) })); }))));
};
export default ValueChipTexfield;
//# sourceMappingURL=ValueChipTexfield.js.map